export const FREE_TIER_ID = Number.MAX_SAFE_INTEGER
